import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import MenuItem from '@adsk/bim360-matrix-react-menu-item';
import SvgIcon from '@adsk/bim360-matrix-react-svg-icon';
import AnchorButton from '@adsk/bim360-matrix-react-anchor-button';
import { ThemeConsumer } from '@adsk/bim360-matrix-react-helpers/es/theme';

import './_MenuItemIcon.scss';

/**
 * MenuItemIcon -  An menu item with an icon based on MenuItem
 */
export default class MenuItemIcon extends MenuItem {
  /**
   * renderChildren
   */
  renderChildren(children) {
    if (children) {
      return <span className="MenuItemIcon__label">{children}</span>;
    }
    return undefined;
  }

  /**
   * render
   */
  render() {
    let svgProps = this.props.svgProps;
    if (this.props.svgId) {
      svgProps = { ...svgProps, svgId: this.props.svgId };
    }

    return (
      <li>
        <ThemeConsumer>
          {({ theme }) => (
            <AnchorButton
              className={classNames('MenuItemIcon', `MenuItemIcon--${theme}`, {
                'MenuItemIcon--disabled': this.props.disabled
              })}
              disabled={this.props.disabled}
              onClick={this._handleOnMenuItemClick}
            >
              <SvgIcon {...svgProps}>{svgProps.svgId ? undefined : svgProps.svg}</SvgIcon>
              {this.renderChildren(this.props.children)}
            </AnchorButton>
          )}
        </ThemeConsumer>
      </li>
    );
  }
}

MenuItemIcon.defaultProps = {
  svgProps: {}
};

MenuItemIcon.propTypes = {
  ...MenuItem.propTypes,
  /**
   * The id of the svg to be used in the item
   */
  svgId: PropTypes.string,
  /**
   * An object containing the props for SvgIcon (svgId is redundant but is kept for backwards dependency)
   */
  svgProps: PropTypes.object,
  /**
   * Determines if the item should be disabled
   */
  disabled: PropTypes.bool
};
